import React, { memo, useCallback } from 'react';
import cc from 'classcat';
import moment from 'moment';
import ControlButton from './ControlButton';
import SingleSlide from './SingleSlide';
import useControls from './useControls';
import './horizontal-slider.style.scss';
/*
 * // TODO: document this
 * @param props
 * @constructor
 */
var HorizontalSlider = function (props) {
    var value = props.value, center = props.center, onChange = props.onChange, slides = props.slides, scrollInterval = props.scrollInterval, className = props.className;
    var _a = useControls({ center: center, value: value, slides: slides, scrollInterval: scrollInterval }), prevSlide = _a.prevSlide, nextSlide = _a.nextSlide, scrollerRef = _a.scrollerRef, isSwiping = _a.isSwiping;
    var onSlideClick = useCallback(function (id) {
        if (!isSwiping) {
            onChange(id);
        }
    }, [isSwiping, onChange]);
    return (React.createElement("div", { className: cc(['date-tab', className]) },
        React.createElement(ControlButton, { onClick: prevSlide, className: "date-tab-control-next" }),
        React.createElement("div", { className: "date-tab-viewport" },
            React.createElement("div", { className: "date-tab-scroller", ref: scrollerRef }, slides.map(function (slide, index) { return (React.createElement(SingleSlide, { slide: slide, key: slide.id, index: index, onClick: onSlideClick, current: slide.id === value, disabled: moment(slide.id).isAfter(moment().endOf('day')) })); }))),
        React.createElement(ControlButton, { onClick: nextSlide, className: "date-tab-control-prev" })));
};
HorizontalSlider.defaultProps = {
    center: true,
    scrollInterval: 5,
};
export default memo(HorizontalSlider);
